import { useSelector } from 'react-redux';
import { I18n } from 'components';
import { getPrice, priceWithDate, priceWithDiscount } from '../../../Home/containers/FamilyWithBeeline/utils';
import declint from '../../../../utils/declint';
import { replaceSubstring } from '../../utils';

export const useInteractionServiceTermsFamily = () => {
  const textFree = 'Бесплатно';
  const {
    content: { serviceTexts },
    price,
    discount,
    count,
    unit,
    isSeb,
    currentEmptyFamPrice,
    invites,
  } = useSelector((state) => state.family);

  const textForNumber = invites.length === 0 ? 'за номер' : '';

  const replacedServiceDescription = replaceSubstring(serviceTexts.serviceDescription, '{{COUNT}}', count);

  const changedDescription = `${replacedServiceDescription} ${declint(
    count,
    ['номера', 'номеров', 'номеров'],
  )}`;

  const socketsDescription = <I18n path={`family.${isSeb ? 'sebDescriptionText' : 'sdbDescriptionText'}`} />;
  const selectedPrice = currentEmptyFamPrice || price;
  const selectedUnit = currentEmptyFamPrice ? '' : unit;

  const discountPrice = priceWithDiscount(discount, unit);
  const discountPriceWithDate = `${priceWithDate(discount, discountPrice)} ${textForNumber}`;

  const priceWithoutDiscount = `${getPrice(selectedPrice, selectedUnit, '', textFree)} ${textForNumber}`;

  return {
    socketsDescription,
    priceWithoutDiscount,
    discountPriceWithDate,
    discountPrice,
    changedDescription,
    serviceTexts,
  };
};
